module.exports = __webpack_public_path__ + "static/media/shaketable_1.65dab7ea.jpg";